import { render, staticRenderFns } from "./CartError.vue?vue&type=template&id=3587d8a6&lang=pug&"
import script from "./CartError.vue?vue&type=script&lang=js&"
export * from "./CartError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports